import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TextField, Paper, AppBar, Toolbar, Typography, Button, Stepper, StepLabel, StepContent, Step } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import './state-css.css'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  }
}));

function getSteps() {
  return ['Contact Information', 'Shipping Information', 'Payment Information'];
}

function getStepContent(step, errorState) {
  switch (step) {
    case 0:
      return <ContactPage errorState={errorState}/>;
    case 1:
      return <ShippingPage errorState={errorState}/>;
    case 2:
      return <PaymentPage errorState={errorState}/>;
    default:
      return 'Unknown step';
  }
}

const ShippingPage = ({errorState = false}) => {
  return (
    <div>
      <TextField label="First Name" helperText="First Name is required" error={errorState}/>&nbsp;
      <TextField label="Last Name" helperText="Last Name is required" error={errorState}/>&nbsp;
      <TextField label="Address" helperText="Address not found"error={errorState}/>&nbsp;
      <TextField label="City" helperText="City is required" error={errorState}/>&nbsp;
      <TextField label="State" helperText="State format invalid" error={errorState}/>&nbsp;
      <TextField label="Zip" helperText="Zip code must have only numbers" error={errorState}/>
    </div>
  )
}

const PaymentPage = ({errorState = false}) => {
  return (
    <div>
      <TextField label="Name on Card" error={errorState} helperText="Name on Card is required"/>&nbsp;
      <TextField label="Credit Card" error={errorState} helperText="Invalid Credit Card Format"/>&nbsp;
      <TextField label="Expiration" error={errorState} helperText="Expiration is required"/>&nbsp;
      <TextField label="CVV" error={errorState} helperText="CVV is required"/>&nbsp;
    </div>
  )
}

const ContactPage = ({errorState = false}) => {
  return (
    <div>
      <TextField label="Phone" error={errorState} helperText="Phone is required"/>&nbsp;
      <TextField label="Email" error={errorState} helperText="Invalid Email"/>&nbsp;
    </div>
  )
}

const ErrorMessage = ({ show, onDismiss }) => {

  const style = { 
    display: show ? 'flex' : 'none'
  }
  return (
    <div className="container" style={style}>
      <p className="error-message" style={{ padding: '5px' }}>{show ? "Sorry, we're experiencing technical difficulties. Please try again later!" : ""}</p>
      <Button onClick={onDismiss} style={{ color: 'white' }}>Dismiss</Button>
    </div>
  )
}

const Funnel = ({defaultStep = 0, errorState = false}) => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(defaultStep);
  const [error, setError] = useState(false);
  const steps = getSteps();

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <div>
      <Paper elevation={3} className={classes.root} id="unique-root">
        <AppBar position="static">
          <Toolbar>
            <Typography variant="h6" className={classes.title}>
              Checkout
            </Typography>
          </Toolbar>
        </AppBar>
        <Paper style={{ width: '100%', height: '500px%' }}>
          <ErrorMessage show={error} onDismiss={() => setError(false)} />
          <div className={classes.root}>
            <Stepper activeStep={activeStep} orientation="vertical">
              {steps.map((label, index) => (
                <Step key={label} activestep={activeStep === index ? 'yes' : 'no'} step={index + 1}>
                  <StepLabel>{label}</StepLabel>
                  <StepContent>
                    <Typography>{getStepContent(index, errorState)}</Typography>
                    <div className={classes.actionsContainer}>
                      <div>
                        <Button
                          disabled={activeStep === 0}
                          onClick={handleBack}
                          className={classes.button}
                        >
                          Back
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => { activeStep === steps.length - 1 ? setError(true) : handleNext() }}
                          className={classes.button}
                        >
                          {activeStep === steps.length - 1 ? 'Submit' : 'Next'}
                        </Button>
                      </div>
                    </div>
                  </StepContent>
                </Step>
              ))}
            </Stepper>
            {activeStep === steps.length && (
              <Paper square elevation={0} className={classes.resetContainer}>
                <Typography>Order complete!</Typography>
                <Button onClick={handleReset} className={classes.button} color="secondary" variant="contained">
                  Start Over
                </Button>
              </Paper>
            )}
          </div>
        </Paper>
      </Paper>
    </div>
  )

}

export default Funnel;